export enum Experiment {
  /**
   * This experiment centres the cards in a slider section when there are too few of them to scroll
   */
  CENTER_SLIDER_CARDS = "center-slider-cards",
}

/**
 * the page urls and signup urls for the online services
 */
export const ONLINE_SERVICES = {
  invoices: {
    page_url: "invoicing",
    signup_url: process.env.GATSBY_ONLINE_PAYMENT_REDIRECT_URL,
  },
  payment_request: {
    page_url: "payment-link",
    signup_url: process.env.GATSBY_ONLINE_PAYMENT_REDIRECT_URL,
  },
  gateway: {
    page_url: "gateway",
    signup_url: process.env.GATSBY_ONLINE_PAYMENT_REDIRECT_URL,
  },
}
